import { type PropsWithChildren } from "react";

import { Header } from "@/src/component/partial/Header";
import { StyledContainer } from "@/src/component/partial/StyledContainer";
import type { StrapiSingleType, StrapiCollectionType } from "@/src/type";

import styles from "./MainLayout.module.scss";

interface MainLayoutProps {
  webConfig: StrapiSingleType.WebConfig;
  page?: StrapiCollectionType.DynamicPage;
  query?: string;
  nav?: StrapiCollectionType.Navigation;
  domainData?: StrapiCollectionType.Domain;
  marketingSources?: StrapiCollectionType.MarketingSource[];
  homePath?: string;
}

function MainLayout({ children, webConfig, page, query, nav, domainData, marketingSources, homePath }: PropsWithChildren<MainLayoutProps>) {
  const queryParams = new URLSearchParams(query);
  const zoom = queryParams.get("zoom");

  /**
   * this is used for the profile branding preview
   */
  if (zoom) {
    return (
      <div style={{ zoom }}>
        <Header
          webConfig={webConfig}
          page={page}
          domainData={domainData}
          marketingSources={marketingSources}
          homePath={homePath}
        />
        <main>{children}</main>
      </div>
    );
  }

  return (
    <StyledContainer
      id={`layoutContainer_${page?.id}`}
      stylePrefix="layoutContainer"
      container={page?.layoutContainer}
      className={styles.styleContainer}
    >
      <Header
        webConfig={webConfig}
        page={page}
        nav={nav}
        domainData={domainData}
        marketingSources={marketingSources}
        homePath={homePath}
      />
      <main>{children}</main>
    </StyledContainer>
  );
}

export default MainLayout;
